import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * TeamDisciplinary — mini-widget "Diffidati & Squalificati" della rosa di una squadra.
 * Mostra chi salta la prossima (squalificato) e chi rischia (diffidato).
 */
export default function TeamDisciplinary({ teamId }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!teamId) return undefined;
        let active = true;
        api.get(`/teams/${teamId}/disciplinary`)
            .then(({ data: d }) => { if (active) setData(d); })
            .catch(() => { if (active) setData({ suspended: [], warnings: [] }); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [teamId]);

    if (!teamId || loading) return null;
    const suspended = data?.suspended || [];
    const warnings = data?.warnings || [];
    if (suspended.length === 0 && warnings.length === 0) return null;

    return (
        <div className="op-card mt-6 overflow-hidden" data-testid="team-disciplinary">
            <div className="px-5 py-4 border-b border-t22252a bg-t0e1014 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <span className="text-2xl">🟥</span>
                    <div>
                        <div className="op-label text-[10px] text-tff7a1a">// SITUAZIONE DISCIPLINARE</div>
                        <div className="text-tffffff op-heading text-lg">Diffidati &amp; Squalificati</div>
                    </div>
                </div>
                <Link to="/disciplinare" className="op-label text-[10px] text-t2bb6ff hover:underline" data-testid="team-disc-all-link">
                    Vedi tutto →
                </Link>
            </div>

            {suspended.length > 0 && (
                <ul className="divide-y divide-t16181c">
                    {suspended.map((p) => (
                        <li key={`s-${p.pes_id}-${p.competition}`} className="px-5 py-3 flex items-center gap-3 text-sm border-l-4 border-tff4d4d" data-testid={`team-disc-susp-${p.pes_id}`}>
                            <div className="flex-1 min-w-0">
                                <div className="text-tffffff font-semibold truncate">{p.name || "—"}</div>
                                <div className="op-mono text-[11px] text-tff7a1a">
                                    {p.competition} · {p.suspension_reason || "squalificato"}
                                </div>
                            </div>
                            <span className="op-label text-[10px] px-2 py-1 border border-tff4d4d text-tff4d4d shrink-0">
                                salta {p.suspended_remaining || 1} giorn.
                            </span>
                        </li>
                    ))}
                </ul>
            )}

            {warnings.length > 0 && (
                <div className={suspended.length > 0 ? "border-t border-t22252a" : ""}>
                    <div className="px-5 pt-3 pb-1 op-label text-[10px] text-te8ff00">🟨 DIFFIDATI · 1 ammonizione alla squalifica</div>
                    <ul className="divide-y divide-t16181c">
                        {warnings.map((p) => (
                            <li key={`w-${p.pes_id}-${p.competition}`} className="px-5 py-2.5 flex items-center gap-3 text-sm" data-testid={`team-disc-warn-${p.pes_id}`}>
                                <div className="flex-1 min-w-0 text-tffffff truncate">{p.name || "—"}</div>
                                <span className="op-mono text-[11px] text-t8f95a3 shrink-0">{p.competition}</span>
                                <span className="op-label text-[9px] px-2 py-1 border border-te8ff00 text-te8ff00 shrink-0">diffidato</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
